import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const quotesTableFields: MapSearchInput['path'] = {
    name: ['id', 'debtorId'],
    date: ['createdAt']
}
